import React from "react";
import { CalendarDays } from "lucide-react";
import { INK, INK_2, INK_3, LINE, BURGUNDY, BG } from "../../Bureau/bureauTokens";
import { holidaysForYear } from "../atoms/holidays";

const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
const MOIS_COURT = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

function isoOf(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
function labelIso(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  return `${JOURS[date.getDay()]} ${date.getDate()} ${MOIS_COURT[date.getMonth()]}`;
}

// Onglet "Jours fériés" — pas de liste éditable (les jours fériés
// eux-mêmes sont un calcul déterministe, voir atoms/holidays.js, pas une
// donnée à saisir) : juste la région et le blocage sur la page de
// réservation. `params`/`onUpdate` viennent de PlanningSettingsModal (même
// ligne ParametresReservation que l'onglet Page de réservation).
function HolidaysSettingsPanel({ params, onUpdate }) {
  const year = new Date().getFullYear();
  const region = params.regionFeries;
  const todayIso = isoOf(new Date());
  const list = Object.entries(holidaysForYear(year, region)).sort(([a], [b]) => a.localeCompare(b));

  return (
    <>
      <div className="mb-3" style={{ background: "#FFF6F8", border: "1px solid #E8C8D2", borderRadius: 10, padding: "12px 14px" }}>
        <div className="flex items-center gap-1.5 text-xs font-semibold mb-2" style={{ color: BURGUNDY }}>
          <CalendarDays size={13} /> Zone applicable
        </div>
        <div className="flex" style={{ border: `1px solid ${LINE}`, borderRadius: 9, overflow: "hidden", width: "fit-content" }}>
          <button
            onClick={() => onUpdate({ regionFeries: "france" })}
            className="text-[11px] font-semibold px-3 py-1.5"
            style={{ background: region === "france" ? BURGUNDY : "#fff", color: region === "france" ? "#fff" : INK_2 }}
          >
            France métropole
          </button>
          <button
            onClick={() => onUpdate({ regionFeries: "reunion" })}
            className="text-[11px] font-semibold px-3 py-1.5"
            style={{ background: region === "reunion" ? BURGUNDY : "#fff", color: region === "reunion" ? "#fff" : INK_2, borderLeft: `1px solid ${LINE}` }}
          >
            La Réunion
          </button>
        </div>
        <label className="flex items-center gap-2 mt-3 text-xs cursor-pointer" style={{ color: INK_2 }}>
          <input type="checkbox" checked={params.bloquerFeries} onChange={(e) => onUpdate({ bloquerFeries: e.target.checked })} />
          <span>
            <b>Bloquer la prise de RDV</b> les jours fériés sur la page de réservation
          </span>
        </label>
        {region === "reunion" && (
          <p className="text-[11px] mt-2" style={{ color: INK_3 }}>
            La Réunion ajoute l'<b>Abolition de l'esclavage</b> (20 décembre) aux 11 jours fériés nationaux.
          </p>
        )}
      </div>

      <div style={{ background: "#FAFAF8", border: `1px solid ${LINE}`, borderRadius: 10, padding: "12px 14px" }}>
        <div className="flex items-center gap-1.5 text-xs font-semibold mb-2" style={{ color: BURGUNDY }}>
          <CalendarDays size={13} /> Jours fériés {year} · {region === "reunion" ? "La Réunion" : "France"}{" "}
          <span style={{ color: INK_3, fontWeight: 600 }}>({list.length})</span>
        </div>
        <div className="flex flex-col gap-1">
          {list.map(([iso, name]) => (
            <div key={iso} className="flex items-center gap-2 px-2.5 py-1.5" style={{ border: `1px solid ${LINE}`, borderRadius: 8, background: "#fff", opacity: iso < todayIso ? 0.55 : 1 }}>
              <span className="text-[10.5px] capitalize" style={{ color: INK_3, minWidth: 110 }}>
                {labelIso(iso)}
              </span>
              <span className="text-xs flex-1" style={{ color: INK }}>
                {name}
              </span>
              {iso >= todayIso && (
                <span className="text-[9.5px] font-bold uppercase px-1.5 py-0.5" style={{ color: INK_3, background: BG, borderRadius: 5 }}>
                  à venir
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default HolidaysSettingsPanel;
